import React from "react";
import IComponentSelect from "react-common-components/dist/components/Select/interface";
import Select from "src/components/Select";
import { useTranslation } from "src/context/Translations/context";
import { ActionGroupers } from "src/pages/Actions/Panel/interface";

const LovGrouperActions: React.FC<Omit<IComponentSelect, "options">> = ({
	name,
	label,
	control,
	...rest
}) => {
	const {translate} = useTranslation();
	return (<Select 
		name={name}
		control={control}
		label={label ?? translate("Agrupadores")}
		options={[
			{ value: ActionGroupers.SECTOR, label: `${translate("Setor")}` },
			{ value: ActionGroupers.SECTOR_RAMMATRIX, label: `${translate("Setor")} -> ${translate("RACI")}` },
			{ value: ActionGroupers.RAMMATRIX, label: `${translate("RACI")}` },
			{ value: ActionGroupers.MAP, label: `${translate("Mapa")}` },
			{ value: ActionGroupers.MAP_INICIATIVE, label: `${translate("Mapa")} -> ${translate("Iniciativa")}` },
			{ value: ActionGroupers.MAP_PERSPECTIVE_INICIATIVE, label: `${translate("Mapa")} -> ${translate("Perspectiva")} -> ${translate("Iniciativa")}` },
			{ value: ActionGroupers.MAP_PERSPECTIVE_OBJECTIVE_INICIATIVE, label: `${translate("Mapa")} -> ${translate("Perspectiva")} -> ${translate("Objetivo")} -> ${translate("Iniciativa")}` },
			{ value: ActionGroupers.SITUATION_MONTH, label: `${translate("Situação")} -> ${translate("Mês previsto de conclusão")}` },
			{ value: ActionGroupers.INDICATOR_CLASSIFICATION, label: `${translate("Classificação do Indicador")}` },
			{ value: ActionGroupers.INDICATOR, label: `${translate("Indicador")}` }, // COMMENT HERE
			// { value: ActionGroupers.INICIATIVE, label: `${translate("Iniciativa")}` }, // COMMENT HERE
			// { value: ActionGroupers.FCA, label: `${translate("FCA")}` }, // COMMENT HERE
			{ value: ActionGroupers.RESPONSIBLE, label: `${translate("Responsável")}` },
			{ value: ActionGroupers.AUTHORITY, label: `${translate("Autoridade")}` },
			{ value: ActionGroupers.MEETING, label: `${translate("Reunião")}` },
			{ value: ActionGroupers.PROGRAM, label: `${translate("Programa")}` },
			{ value: ActionGroupers.PROGRAM_PROJECT, label: `${translate("Programa")} -> ${translate("Projeto")}` },
			{ value: ActionGroupers.PROGRAM_PROJECT_PHASE, label: `${translate("Programa")} -> ${translate("Projeto")} -> ${translate("Fase")}` },
			{ value: ActionGroupers.RISK, label: `${translate("Risco")}` },
			// { value: ActionGroupers.FACT_CAUSE_OCCURENCE, label: `${translate("Fato e causa da Ocorrência")}` }, // COMMENT HERE
			{ value: ActionGroupers.OCCURRENCE, label: `${translate("Ocorrência")}` },
			// { value: ActionGroupers.RISK_ANALYSIS, label: `${translate("Análises do risco")}` }, // COMMENT HERE
			{ value: ActionGroupers.OKR, label: `${translate("OKR")}` },
			{ value: ActionGroupers.OKR_INICIATIVE, label: `${translate("OKR")} -> ${translate("Iniciativa")}` },
			{ value: ActionGroupers.OKR_KEYRESULTS_INICIATIVE, label: `${translate("OKR")} -> ${translate("Resultado Chave")} -> ${translate("Iniciativa")}` },
			// { value: ActionGroupers.ACTIONS_WITH_SUBACTIONS, label: `${translate("Ações com subações")}` }, //Agrupamento descontinuado pois causava query ambiguas entre ações e subações
			{ value: ActionGroupers.SITUATION, label: `${translate("Situação")}` },
			{ value: ActionGroupers.ORIGIN, label: `${translate("Origem")}` },
			{ value: ActionGroupers.KANBAN, label: "Kanban" },
			{ value: ActionGroupers.KANBAN_QUADRANT, label: `Kanban -> ${translate("Quadrante")}` }
		]}
		{...rest}
	/>);
};

export default LovGrouperActions;
